import { Navigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import { ReactNode } from 'react'

interface Props {
  children: ReactNode
}

export const ProtectedRoute = ({ children }: Props) => {
  const { user } = useAuth()
  if (!user) {
    return <Navigate to="/login" />
  }
  return <>{children}</>
}
